import { Link } from "react-router-dom";
import type { CustomerForm } from "../../types/forms";
import { formTypeLabel, formatFormTime } from "../../shared/customerForms";
import FormStatusBadge from "./FormStatusBadge";

export default function FormsList({
  forms,
  returnTo,
}: {
  forms: CustomerForm[];
  returnTo: string;
}) {
  return (
    <>
      <div className="space-y-3 md:hidden">
        {forms.map((form) => (
          <Link
            key={`${form.type}-${form.id}`}
            to={`/forms/${form.type}/${form.id}`}
            state={{ returnTo }}
            className="block rounded-xl border border-gray-200 bg-white p-5 hover:border-primary-300"
          >
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="font-semibold text-primary-700">{form.reference}</span>
              <FormStatusBadge status={form.status} />
            </div>
            <p className="mt-2 text-xs text-gray-500">{formTypeLabel(form.type)}</p>
            <h2 className="mt-1 font-medium">{form.customer_name}</h2>
            <p className="mt-1 text-sm">{form.invoice_number || form.event_name}</p>
            <p className="mt-3 text-xs text-gray-500">
              Submitted by {form.submitted_by} · {formatFormTime(form.created_at)}
            </p>
            <p className="mt-1 text-xs text-gray-500">Updated {formatFormTime(form.updated_at)}</p>
          </Link>
        ))}
      </div>
      <div className="hidden md:block overflow-x-auto rounded-xl border border-gray-200 bg-white">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              {[
                "Reference / Type",
                "Customer",
                "Invoice / Event",
                "Status",
                "Submitted by",
                "Submitted",
                "Updated",
              ].map((h) => (
                <th className="px-4 py-3 font-medium" key={h}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {forms.map((form) => (
              <tr key={`${form.type}-${form.id}`} className="hover:bg-gray-50">
                <td className="px-4 py-4">
                  <Link
                    className="font-semibold text-primary-700 underline"
                    to={`/forms/${form.type}/${form.id}`}
                    state={{ returnTo }}
                  >
                    {form.reference}
                  </Link>
                  <p className="mt-1 text-xs text-gray-500">{formTypeLabel(form.type)}</p>
                </td>
                <td className="px-4 py-4">{form.customer_name}</td>
                <td className="px-4 py-4">{form.invoice_number || form.event_name}</td>
                <td className="px-4 py-4 whitespace-nowrap">
                  <FormStatusBadge status={form.status} />
                </td>
                <td className="px-4 py-4">{form.submitted_by}</td>
                <td className="px-4 py-4 whitespace-nowrap">{formatFormTime(form.created_at)}</td>
                <td className="px-4 py-4 whitespace-nowrap">{formatFormTime(form.updated_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
